import { Component, OnInit } from '@angular/core';
import { PostnewJob } from '../../services/job-section.service';
import { LoginService } from 'src/app/core/services/login.service';
import { Router } from '@angular/router';
import { JobDetailsPreviewComponent } from '../job-details-preview/job-details-preview.component';
import { MatDialog } from '@angular/material/dialog';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-enquiries-jobs-listing',
  templateUrl: './enquiries-jobs-listing.component.html',
  styleUrls: ['./enquiries-jobs-listing.component.scss']
})
export class EnquiriesJobsListingComponent implements OnInit {

  constructor(private jobService: PostnewJob, private loginService: LoginService, private router: Router, private dialog: MatDialog) { }
  loginDetails: any;
  myEnquiryAllList: any;
  // myEnquiryJob: any;
  openEnquiryAccordionId: string | null = null;
  enquiryData: any[];
  newMessage: string = '';
  openAccordionId: string | null = null;
  displayMessage: any[] = [];
  EditedMessageId: string = '';

  subscriptionRef: Subscription | null = null;

  loaderMessage = true;
  loaderEnquiry = true;
  dataLoader = true;

  ngOnInit(): void {
    this.loginDetails = this.loginService.getLoginData();

    this.loadMoreEnquiries();

  }

  viewJob(jobId: string | number): void {

    this.dialog.open(JobDetailsPreviewComponent, {
      width: '60%',
      panelClass: ['custom-modal'],
      data: { id: jobId }   // send only the id
    });
  }


  limit = 5;
  offset = 0;
  loading = false;
  endOfData = false;

  myEnquiryJob: any[] = [];

  loadMoreEnquiries(): void {

    if (this.loading || this.endOfData) return;

    this.loading = true;

    this.jobService.getMyEnquiryJobs(this.limit, this.offset).subscribe({
      next: (jobs) => {

        const enrichedJobs = jobs;

        if (enrichedJobs.length < this.limit) {
          this.endOfData = true;
        }

        this.myEnquiryJob = [...this.myEnquiryJob, ...enrichedJobs];
        this.offset += this.limit;
        this.loading = false;
        this.dataLoader =false;

      },
      error: (err) => {
        console.error("Error fetching enquiry jobs:", err);
        this.loading = false;
        this.dataLoader =false;
      }
    });


  }

  // Enquiry
  EnquiryAcoordion(jobs: any): void {
    // Close the message accordion when opening the enquiry accordion
    this.openAccordionId = null;
    this.loaderEnquiry = true;
    this.enquiryData = [];

    this.openEnquiryAccordionId = this.openEnquiryAccordionId === jobs.id ? null : jobs.id;

    const jobID = jobs?.job_id;
    const userId = jobs?.enquiry_userid;

    this.jobService.getApplicantEnquiry(jobID, userId).subscribe({
      next: (data) => {
        this.enquiryData = data;
        this.loaderEnquiry = false;
      },
      error: () => {
        this.loaderEnquiry = false;
      }
    });

  }

  messageAcordion(job: any): void {
    // Close the enquiry accordion when opening the message accordion
    const jobId = job.id;
    this.openEnquiryAccordionId = null;

    if (this.openAccordionId === jobId) {
      this.openAccordionId = null;
      this.displayMessage = [];
      this.subscriptionRef?.unsubscribe(); // stop subscription
      return;
    }

    this.openAccordionId = jobId;
    this.loaderMessage = true;
    this.newMessage = '';
    this.displayMessage = [];

    this.subscriptionRef?.unsubscribe();

    this.subscriptionRef = this.jobService
      .getApplicantMessage(job?.job_applicants_find?.id, job?.id)
      .subscribe({
        next: (data) => {
          this.displayMessage = data; // show only this job's messages
          this.loaderMessage = false;
        },
        error: () => {
          this.loaderMessage = false;
        },
      });

  }


  // getAllMessage(ApplicantId: any, EnquiryId: any) {

  //   this.jobService
  //     .getApplicantMessage(ApplicantId, EnquiryId)
  //     .subscribe({ next :(data) => {
  //       this.displayMessage = data;
  //       this.loaderMessage = false;
  //     },
  //     error :()=>{
  //       this.loaderMessage = false;
  //     }
  //     });
  // }



  // send message

  sendMessage(jobId: any): void {

    if (!this.newMessage.trim()) return; // Do not send empty messages

    // Applied Job Message
    const messages = {
      message: this.newMessage,
      message_from: this.loginDetails.id,
      job_enquiry_id: jobId.id
    };

    this.jobService.addApplicantMessage(messages);

    this.newMessage = ''; // Clear the input box
  }


  deleteMessage(messageId: string): void {

    this.jobService.deleteApplicantMessage(messageId).then(() => {

    }).catch((err) => {
      console.error("Error deleting message:", err);
    })
  }

  editMessage(message: any): void {
    this.newMessage = message.message;
    this.EditedMessageId = message.id;
  }

  UpdateMessage(editId: any): void {

    const UpdateMessage = {
      id: editId,
      message: this.newMessage,
    }

    this.jobService.editApplicantMessages(UpdateMessage.id, UpdateMessage.message).then(() => {
      this.EditedMessageId = '';
      this.newMessage = '';
    })

  }

  trackByJobId(index: number, job: any): string {

    return job.id;
  }

  getInitial(name: string | undefined | null): string {
    if (!name) return '';
    return name
      .split(' ')
      .map(word => word[0])
      .join('')
      .toUpperCase()
      .slice(0, 2); // max 2 initials
  }


}
